import { connect } from 'react-redux'
import { withWizard } from 'react-albus'
import {
  setLayoutVehiclePreview,
  setLayoutTradeInPreview,
  setLayoutModalInfo
} from 'core/templates/actions'
import WizardNavigation from './WizardNavigation'

const mapStateToProps = state => ({
  wizards: state.wizards,
  configurator: state.configurator,
  stock: state.stock,
  tradeIn: state.tradeIn,
  layoutTradeIn: state.layout.tradeIn,
  configuration: state.configuration,
})
const mapDispatchToProps = { setLayoutVehiclePreview, setLayoutTradeInPreview, setLayoutModalInfo }

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withWizard(WizardNavigation))
